import { render, staticRenderFns } from "./BlogTemplate.vue?vue&type=template&id=3874bbb3&scoped=true&"
import script from "./BlogTemplate.vue?vue&type=script&lang=js&"
export * from "./BlogTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BlogTemplate.vue?vue&type=style&index=0&id=3874bbb3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3874bbb3",
  null
  
)

export default component.exports